import { useCallback, useEffect, useState } from 'react'
import { fetchTenantModulesService } from '@/lib/services/module.service'
import type { AppModule } from '@/types/models/module'

export function useTenantModules(tenantId?: number | null, enabled = true) {
  const [modules, setModules] = useState<AppModule[]>([])
  const [isLoading, setIsLoading] = useState(enabled)
  const [loadedTenantId, setLoadedTenantId] = useState<number | null>(null)
  const [error, setError] = useState<unknown>(null)

  const refetch = useCallback(async () => {
    if (!enabled || !tenantId) {
      setModules([])
      setLoadedTenantId(null)
      setIsLoading(false)
      return
    }

    try {
      setIsLoading(true)
      setLoadedTenantId(null)
      setError(null)
      setModules(await fetchTenantModulesService(tenantId))
    } catch (requestError) {
      setModules([])
      setError(requestError)
    } finally {
      setLoadedTenantId(tenantId ?? null)
      setIsLoading(false)
    }
  }, [enabled, tenantId])

  useEffect(() => { void refetch() }, [refetch])

  return {
    modules,
    isLoading: isLoading || Boolean(enabled && tenantId && loadedTenantId !== tenantId),
    error,
    refetch,
  }
}
